import { StateCreator } from 'zustand';

export interface UIStateSlice {
  ui: {
    device?: 'desktop' | 'mobile';
    error: {
      title?: string;
      message?: string;
      confirmation?: {
        onClose?: () => void;
        action?: () => void;
        text?: string;
      };
    };
    loading: {
      state: boolean;
      priority: boolean;
    }
    logInDialog: boolean;
    isInsideCard: boolean;
    isSlotsLoading: boolean;
    methods: {
      setDevice: (device: 'desktop' | 'mobile') => void;
      setErrorModal: (
        title: string,
        message?: string,
        confirmation?: {
          onClose?: () => void;
          action?: () => void;
          text?: string;
        },
      ) => void;
      setInitialLoading: (loading: boolean, priority: boolean) => void;
      setInsideCard: (isInsideCard: boolean) => void;
      setLogInDialog: (open: boolean) => void;
      setIsSlotsLoading: (loading: boolean) => void;
    };
  };
}

const createUIStateSlice: StateCreator<UIStateSlice> = (set) => ({
  ui: {
    error: {
      title: '',
      message: '',
    },
    loading: {
      state: true,
      priority: true,
    },
    logInDialog: false,
    isInsideCard: true,
    isSlotsLoading: false,
    methods: {
      setDevice: (device: 'desktop' | 'mobile') => {
        set((state) => ({
          ui: {
            ...state.ui,
            device,
          },
        }));
      },
      setErrorModal: (
        title: string,
        message?: string,
        confirmation?: {
          action?: () => void;
          text?: string;
          onClose?: () => void;
        },
      ) => {
        set((state) => ({
          ui: {
            ...state.ui,
            error: {
              title,
              message,
              confirmation,
            },
          },
        }));
      },
      setInitialLoading: (loading: boolean, priority) => {
        set((state) => ({
          ui: {
            ...state.ui,
            loading: {
              state: loading,
              priority,
            },
          },
        }));
      },
      setInsideCard: (isInsideCard: boolean) => {
        set((state) => ({
          ui: {
            ...state.ui,
            isInsideCard,
          },
        }));
      },
      setIsSlotsLoading: (loading: boolean) => {
        set((state) => ({
          ui: {
            ...state.ui,
            isSlotsLoading: loading,
          },
        }));
      },
      setLogInDialog: (open: boolean) => {
        set((state) => ({
          ui: {
            ...state.ui,
            logInDialog: open,
          },
        }));
      },
    },
  },
});

export default createUIStateSlice;
